import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const Youtube: React.FC<IconPresentationProps> = props => {
    return (
        <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.173 10.48a.928.928 0 0 1 .934.013l6.187 3.711a.928.928 0 0 1 0 1.591l-6.187 3.712a.928.928 0 0 1-1.405-.796v-7.423c0-.334.18-.643.47-.807z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.207 5.412a3.402 3.402 0 0 0-3.402 3.402v12.372a3.402 3.402 0 0 0 3.402 3.402h19.795a3.402 3.402 0 0 0 3.403-3.402V8.814a3.402 3.402 0 0 0-3.403-3.402H5.207zM3.661 8.814c0-.854.692-1.547 1.546-1.547h19.795c.855 0 1.547.693 1.547 1.547v12.372c0 .854-.692 1.547-1.547 1.547H5.207a1.546 1.546 0 0 1-1.546-1.547V8.814z"
                fill="#fff"
            />
        </svg>
    );
};

export default React.memo(Youtube);
